import React from "react";

const TermsAndConditions = () => {
  const handleScrollToBottom = () => {
    const container = document.getElementById("termsContainer");
    container.scrollTo({
      top: container.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleScrollToTop = () => {
    const container = document.getElementById("termsContainer");
    container.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", maxWidth: "800px", margin: "0 auto" }}>
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h1 style={{ fontSize: "20px", fontWeight: "bold" }}>Terms and Conditions</h1>
        <p style={{ fontSize: "12px", color: "gray" }}>Last updated 10/31/2024</p>
      </div>
      <div
        id="termsContainer"
        style={{
          height: "400px",
          overflowY: "scroll",
          border: "1px solid #ddd",
          borderRadius: "10px",
          padding: "15px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          lineHeight: "1.4",
          fontSize: "12px",
        }}
      >
        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>1. No Legal Advice Disclaimer</h2>
        <p>
          Divori is an AI-powered platform designed to provide informational guidance based on user input. However, we do
          not offer legal advice or any other professional services. The content generated by the platform is for
          informational purposes only and should not be interpreted as a substitute for legal consultation. Users are
          encouraged to seek advice from a qualified professional regarding their specific situation.
        </p>

        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>2. Accuracy of Information</h2>
        <p>
          The information provided by Divori is generated based on the data input by users. While we strive to ensure
          the quality and accuracy of the information, we cannot guarantee its correctness, completeness, or
          applicability. Users are responsible for verifying and validating the relevance of the information before
          taking any action.
        </p>

        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>3. Limitation of Liability</h2>
        <p>
          Divori and its operators shall not be held liable for any direct, indirect, incidental, or consequential
          damages arising from the use or inability to use the platform. This includes, but is not limited to, damages
          resulting from financial loss, data inaccuracies, or decisions made based on the content provided.
        </p>

        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>4. No Refund Policy</h2>
        <p>
          All purchases and payments made through Divori are final and non-refundable. Due to the nature of the
          services provided, users acknowledge and accept that refunds cannot be issued once payment is processed. If
          you encounter issues, please contact our support team at{" "}
          <a href="mailto:divori.solutions@gmail.com">divori.solutions@gmail.com</a>.
        </p>

        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>5. User Responsibilities</h2>
        <p>
          By accessing and using Divori, you agree to:
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li>Provide accurate, complete, and up-to-date information when prompted.</li>
          <li>
            Use the platform solely for personal or informational purposes and not for any illegal, unethical, or
            harmful activities.
          </li>
          <li>
            Not hold Divori liable for any decisions, actions, or consequences resulting from the use of the platform.
          </li>
        </ul>

        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>6. Intellectual Property</h2>
        <p>
          All content, designs, logos, and other intellectual property associated with Divori are owned exclusively by
          Divori and its licensors. Users are not permitted to copy, distribute, or modify any part of the platform
          without prior written consent.
        </p>

        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>7. Changes to Terms</h2>
        <p>
          Divori reserves the right to update or modify these Terms and Conditions at any time. Changes will take effect
          immediately upon being posted on the platform. Users are encouraged to review these terms regularly to stay
          informed.
        </p>

        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>8. Governing Law</h2>
        <p>
          These Terms and Conditions are governed by and construed in accordance with the laws of [Your Country/State].
          Any disputes arising from or relating to the use of the platform shall be resolved exclusively in the courts
          of [Jurisdiction].
        </p>

        <h2 style={{ fontSize: "14px", marginBottom: "10px" }}>9. Contact Us</h2>
        <p>
          For any questions or concerns regarding these Terms and Conditions, please contact us at:
        </p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:divori.solutions@gmail.com">divori.solutions@gmail.com</a>
        </p>
      </div>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          onClick={handleScrollToBottom}
          style={{
            padding: "8px 16px",
            margin: "5px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            fontSize: "12px",
            cursor: "pointer",
          }}
        >
          Scroll to Bottom
        </button>
        <button
          onClick={handleScrollToTop}
          style={{
            padding: "8px 16px",
            margin: "5px",
            backgroundColor: "#f8f9fa",
            color: "#333",
            border: "1px solid #ddd",
            borderRadius: "5px",
            fontSize: "12px",
            cursor: "pointer",
          }}
        >
          Scroll to Top
        </button>
      </div>
    </div>
  );
};

export default TermsAndConditions;